import { render, staticRenderFns } from "./SalesmanDetailsView.vue?vue&type=template&id=c1c8be4a"
import script from "./SalesmanDetailsView.vue?vue&type=script&lang=js"
export * from "./SalesmanDetailsView.vue?vue&type=script&lang=js"
import style0 from "./SalesmanDetailsView.vue?vue&type=style&index=0&id=c1c8be4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports